"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Audio = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Audio = function Audio(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      height: props.height,
      width: props.width,
      fill: props.color,
      viewBox: "0 0 55 80",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("g", {
      transform: "matrix(1 0 0 -1 0 80)"
    },
    /*#__PURE__*/
    _react["default"].createElement("rect", {
      width: "10",
      height: "20",
      rx: "3"
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "4.3s",
      values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("rect", {
      x: "15",
      width: "10",
      height: "80",
      rx: "3"
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "2s",
      values: "80;55;33;5;75;23;73;33;12;14;60;80",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("rect", {
      x: "30",
      width: "10",
      height: "50",
      rx: "3"
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "1.4s",
      values: "50;34;78;23;56;23;34;76;80;54;21;50",
      calcMode: "linear",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("rect", {
      x: "45",
      width: "10",
      height: "30",
      rx: "3"
    },
    /*#__PURE__*/
    _react["default"].createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "2s",
      values: "30;45;13;80;56;72;45;76;34;23;67;30",
      calcMode: "linear",
      repeatCount: "indefinite"
    }))))
  );
};

exports.Audio = Audio;
Audio.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string
};
Audio.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading"
};